class MultiVariantForm extends HTMLElement {
    #total = 0;
    #variants = [];
    #selectedVariants = [];
    #form = undefined;
    #inCard = false;

    constructor() {
        super();
        this.#inCard = this.dataset.inCard == "true";
        this.miniCart = document.querySelector("mini-cart");
        this.#form = this.querySelector("form");
        this.init();
    }

    init() {
        const jsonScripts = Array.from(this.querySelectorAll("script[type='application/json']"));
        this.#variants = jsonScripts.map((script) => JSON.parse(script.textContent));

        if (this.#inCard) {
            this.addEventListener("change", this.onChangeInCard.bind(this));
            const swatches = this.querySelectorAll(".c-multi-variant-form__list input[type='radio'] + label");

            swatches.forEach((swatch) => {
                swatch.addEventListener("click", (e) => {
                    e.preventDefault();
                    const topParent = swatch.closest(".ba-c-product-wide-card");
                    const images = Array.from(topParent.querySelectorAll(".ba-c-product-wide-card__image"));
                    const variantImage = images.find((image) => image.dataset.title == swatch.title);

                    images.forEach((image) => image.classList.remove("is-active"));
                    
                    if (variantImage) {
                        variantImage.classList.add("is-active");
                    } else {
                        images[0].classList.add("is-active");
                    }
                });
            });
        } else {
            this.addEventListener("change", this.onChange.bind(this));
            this.#form.addEventListener("submit", this.onSubmitHandler.bind(this));
        }

        const radios = this.querySelectorAll("input[type='radio'] + label");

        radios.forEach((radio) => {
            radio.addEventListener("click", (e) => this.toggleSwatches(e, radios));
        });
    }

    onChange(e) {
        const { target } = e;
        const variantId = Number(target.dataset.variantId);
        const quantity = Number(target.value);
        const variant = this.#variants.find((variant) => variant.id == variantId);

        this.setTotal({ id: variantId, price: variant?.price, quantity });
    }

    onChangeInCard(e) {
        e.preventDefault();
        const { target } = e;
        const variantId = Number(target.dataset.variantId);
        const quantity = Number(target.value);
        const inCart = target.dataset.inCart == "true";
        const cartKey = target.dataset.cartKey;
        const notificationEl = target
            .parentElement
            .parentElement
            .nextElementSibling;
        const changeEvent = new CustomEvent("cardQtyInput:change", {
            detail: {
                variantId,
                quantity
            }
        });

        document.dispatchEvent(changeEvent)

        this.updateCart({ variantId, quantity, cartKey, inCart, notificationEl });
    }

    async updateCart({ variantId, quantity, cartKey, inCart, notificationEl }) {
        const END_POINT = inCart ? "/cart/change.js" : "/cart/add.js";
        const sections = this.getSectionsToRender().map((section) => section.id);
        let item = { sections, sections_url: window.location.pathname };

        if (inCart) {
            let key = cartKey || variantId;

            item = { ...item, id: key, quantity };
        } else {
            item = {
                ...item,
                items: [
                    {
                        id: variantId,
                        quantity,
                    },
                ],
            };
        }

        try {
            const response = await fetch(END_POINT, {
                method: "POST",
                body: JSON.stringify(item),
                headers: {
                    "Content-Type": "application/json",
                },
            });

            notificationEl.classList.remove("is-hidden");
            setTimeout(() => notificationEl.classList.add("is-hidden"), 2000);

            const data = await response.json();
            this.getSectionsToRender().forEach((section) => {
                if (document.getElementById(section.id)) {
                    document.getElementById(section.id).innerHTML =
                        this.getSectionInnerHTML(
                            data.sections[section.id],
                            section.selector,
                        );
                }
            });

            this.dataset.inCart = true;
        } catch (error) {
            console.log(error);
        }
    }

    getSectionsToRender() {
        return [
            {
                id: "mini-cart",
                section: "mini-cart",
                selector: ".shopify-section",
            },
            {
                id: "cart-icon-bubble",
                section: "cart-icon-bubble",
                selector: ".shopify-section",
            },
            {
                id: "mobile-cart-icon-bubble",
                section: "mobile-cart-icon-bubble",
                selector: ".shopify-section",
            },
        ];
    }

    getSectionInnerHTML(html, selector = ".shopify-section") {
        return new DOMParser()
            .parseFromString(html, "text/html")
            .querySelector(selector).innerHTML;
    }

    setTotal({ id, price, quantity }) {
        const totalEl = this.querySelector(".c-multi-variant-form__total-amount");
        const index = this.#selectedVariants.findIndex((variant) => variant.id == id);

        if (index >= 0) {
            this.#selectedVariants[index] = { id, price, quantity }
        } else {
            this.#selectedVariants.push({
                id,
                price, 
                quantity
            });
        }

        this.#total = this.#selectedVariants
            .reduce((previousValue, currentValue) => previousValue + (currentValue.price * currentValue.quantity), 0);

        totalEl.textContent =  theme.Currency.formatMoney(this.#total, window.shopSettings.moneyFormat);
    }

    onSubmitHandler(e) {
        if (document.body.classList.contains("template-cart") || !window.shopSettings.cartDrawer) return;

        e.preventDefault();
        const submitButton = this.querySelector('[type="submit"]');

        if (submitButton.classList.contains("loading")) return;

        this.handleErrorMessage();
        submitButton.setAttribute("aria-disabled", true);
        submitButton.classList.add("loading");

        let formData = {
            items: this.#selectedVariants.map(({ id, quantity }) => {
                return {
                    id,
                    quantity
                }
            }),
            "sections_url": window.location.pathname
        };

        if (this.miniCart) {
            formData["sections"] = this.miniCart.getSectionsToRender().map((section) => section.id)
        }

        fetch(`${window.routes.cart_add_url}.js`, {
            method: "POST",
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(formData)
        })
            .then((response) => response.json())
            .then((response) => {
                if (response.status) {
                    this.handleErrorMessage(response.description);
                    return;
                }

                if (this.miniCart) {
                    this.miniCart.renderContents(response);
                }
            })
            .catch((e) => {
                console.error(e);
            })
            .finally(() => {
                submitButton.classList.remove("loading");
                submitButton.removeAttribute("aria-disabled");
            });
    }

    handleErrorMessage(errorMessage = false) {
        this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector(".product-form__error-message-wrapper");
    
        if (this.errorMessageWrapper) {
          this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector(".product-form__error-message");
          this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);
    
          if (errorMessage) {
            this.errorMessage.textContent = errorMessage;
          }

        } else {
          if (errorMessage) {
            alert(errorMessage);
          }
        }
    }

    toggleSwatches(e, radios) {
        const parent = e.target.parentElement;
        const input = parent.firstElementChild;

        radios.forEach(radio => {
            const parentRadio = radio.parentElement;
            const inputRadio = parentRadio.firstElementChild;

            inputRadio.checked = false;
        });

        input.checked = true;
    }
}

customElements.define("multi-variant-form", MultiVariantForm);